/**
 * Stats Card Component
 * Displays a single metric with label and optional subtitle
 */

import clsx from 'clsx';

interface StatsCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  variant?: 'default' | 'profit' | 'warning' | 'danger';
  className?: string;
}

export function StatsCard({
  label,
  value,
  subtitle,
  variant = 'default',
  className,
}: StatsCardProps) {
  const variantStyles = {
    default: 'text-blue-600',
    profit: 'text-green-600',
    warning: 'text-amber-600',
    danger: 'text-red-600',
  };

  return (
    <div
      className={clsx(
        'bg-white rounded-xl p-5 border border-gray-200 transition-all hover:shadow-md hover:-translate-y-0.5',
        className
      )}
    >
      <div className="text-sm text-gray-500 mb-2">{label}</div>
      <div className={clsx('text-2xl font-bold', variantStyles[variant])}>
        {value}
      </div>
      {subtitle && (
        <div className="text-xs text-gray-400 mt-1">{subtitle}</div>
      )}
    </div>
  );
}
